<template>
    <div>
      <h3>Worker ID: {{taskData.worker_id}}</h3>

      <b-container class="text-left p-3">
        <b-row>
        <b-col sm="8">
          <h4>User Info</h4>
          <p>Account Progress: {{userData.account_progress}}</p>
        </b-col>
        <b-col>
          <h4>Task Info</h4>
          <p>Condition: {{taskData.time_series_condition}}</p>
          <p>Drop Data? {{taskData.drop}}</p>
          <p>Task progress: {{taskData.task_progress}}</p>
          <p>Dataset Direction: {{taskData.dataset_direction}}</p>
        </b-col>
        </b-row>
        <b-row>
        <b-col sm="8">
          <h4>Timestamps</h4>
          <p>Create Account: {{taskData.start_time}}</p>
          <p>Finish Demo: {{userData.finish_demo}}</p>
          <p>Finish IMC: {{taskData.finish_imc}}</p>
          <p>Finish intro: {{taskData.finish_intro}}</p>
          <p>Finish learning: {{taskData.finish_learning}}</p>
          <p>Finish Question: {{taskData.finish_question}}</p>
          <p>Finish Study: {{userData.finish_time}}</p>
        </b-col>
        <b-col>
          <h4>Dependent Measures</h4>
          <p>Causal Strength: {{taskData.causal_strength}}</p>
          <p>Explaination: {{taskData.explain_note}}</p>
          <p>Prediction Continue: {{taskData.pred_continue}}</p>
          <p>Prediction Stop: {{taskData.pred_stop}}</p>
        </b-col>
        </b-row>
        <b-row>
        <b-col sm="8">
          <h4>Exit Question</h4>
          <p>if bugs? {{userData.if_bugs}}</p>
          <p>bug notes: {{userData.notes_bug}}</p>
          <p>general notes: {{userData.notes_general}}</p>
        </b-col>
        <b-col>
          <h4>IMC</h4>
          <p>imc_click: {{taskData.imc_click}}</p>
          <p>imc_sports: {{taskData.imc_sports}}</p>
        </b-col>
        </b-row>
      </b-container>
        <h4>Trial Data</h4>
      <table class="table table-hover m-3">
          <thead>
            <tr>
              <th>Trial #</th>
              <th>Level</th>
              <th>Prediction</th>
              <th>Trial RT</th>
              <th>Memory Trend</th>
              <th>Submit Time</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index in 14" :key="index">
              <td>{{ taskData.trials[index-1].day }}</td>
              <td>{{ taskData.trials[index-1].level }}</td>
              <td>{{ taskData.predict_effect[index-1] }}</td>
              <td>{{ taskData.trial_rt[index-1] }}</td>
              <td>{{ taskData.draw_trend[index-1] }}</td>
              <td>{{ taskData.finish_trial_time[index-1] }}</td>
            </tr>
          </tbody>
        </table>
    </div>
</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      taskData: {},
      userData: {},
    };
  },
  methods: {
    getUserData() {
      const path = `${this.$hostname}/get-taskdata/${this.$route.params.id}`;
      axios
        .get(path)
        .then((res) => {
          console.log(res.data.Auth);
          if (res.data.Auth !== 'admin') {
            this.$router.push({ name: 'Task' });
          } else {
            this.taskData = res.data.task_data;
            this.userData = res.data.user_data;
            console.log(res.data.task_data);
            console.log(res.data.user_data);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
  },
  created() {
    this.getUserData();
  },
};
</script>
